var map = {
	"./adverts.vue": [
		"ijUk",
		20
	],
	"./hero.vue": [
		"6rI0",
		17
	],
	"./links.vue": [
		"qou8",
		19
	],
	"./navigation.vue": [
		"bHhU",
		18
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "wMXs";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/sections lazy ^\.\/.*\.vue$
// module id = wMXs
// module chunks = 0